import {FAVORITES_KEY, FAVORITES_LIMIT, normalizeConfiguration, configurationKey, parseFavorites, configurationUrl} from './scl-favorites-store.js?v=2026092202';
import {createFavoritesSheet} from './scl-favorites-sheet.js?v=2026092204';

const dialog = document.querySelector('#shej-favorites');
if (dialog) {
  let saveButton = document.querySelector('[data-favorite-save]');
  const toast = document.querySelector('[data-favorite-toast]');
  const list = dialog.querySelector('[data-favorites-list]');
  const empty = dialog.querySelector('[data-favorites-empty]');
  const status = dialog.querySelector('[data-favorites-status]');
  const cartLink = dialog.querySelector('[data-favorites-cart-link]');
  const sheet = createFavoritesSheet(dialog);
  let adding = false, handoffToCart = false;
  let current = null, loading = false, items = [], opener = null, toastTimer = 0, scrollTop = 0, returnToViewer = false;
  const read = () => { try { return parseFavorites(localStorage.getItem(FAVORITES_KEY)); } catch { return []; } };
  const message = text => {
    if (dialog.open) { status.textContent = text; return; }
    clearTimeout(toastTimer); toast.textContent = text; toast.hidden = false;
    toastTimer = setTimeout(() => { toast.hidden = true; }, 2600);
  };
  function sync() {
    saveButton = document.querySelector('[data-favorite-save]');
    document.querySelectorAll('[data-favorites-count]').forEach(badge => { badge.textContent = String(items.length); badge.hidden = items.length === 0; });
    if (!saveButton) return;
    const saved = current && items.some(item => configurationKey(item) === configurationKey(current));
    saveButton.disabled = !current || loading;
    saveButton.setAttribute('aria-pressed', String(Boolean(saved)));
    saveButton.setAttribute('aria-label', saved ? dialog.dataset.remove : dialog.dataset.add);

  }
  function write(next) {
    try { localStorage.setItem(FAVORITES_KEY, JSON.stringify(next)); }
    catch { message(dialog.dataset.error); return false; }
    items = next; sync(); if (dialog.open) render(); return true;
  }
  function render() {
    list.replaceChildren(); empty.hidden = items.length > 0;
    for (const item of items) {
      const key = configurationKey(item), row = document.createElement('article'), open = document.createElement('a'), image = document.createElement('img'), details = document.createElement('span'), name = document.createElement('strong'), model = document.createElement('span'), remove = document.createElement('button');
      row.className = 'shej-favorites-item'; open.className = 'shej-favorites-configuration';
      open.href = configurationUrl(dialog.dataset.home, item, location.origin);
      open.addEventListener('click', event => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const apply = new CustomEvent('shejtano:configuration-apply', {detail: item, cancelable: true});
        document.dispatchEvent(apply);
        if (!apply.defaultPrevented) return;
        event.preventDefault(); returnToViewer = true; dialog.close();
      });
      open.setAttribute('aria-label', dialog.dataset.view + ': ' + item.artwork + ', ' + item.modelName);
      image.src = item.image; image.alt = item.artwork; image.width = 76; image.height = 96; image.loading = 'lazy'; image.decoding = 'async';
      name.textContent = item.artwork; model.textContent = item.modelName;
      details.append(name, model); open.append(image, details);
      remove.type = 'button'; remove.className = 'shej-favorites-remove'; remove.textContent = '×';
      remove.setAttribute('aria-label', dialog.dataset.remove + ': ' + item.artwork + ', ' + item.modelName);
      remove.addEventListener('click', () => {
        const latest = read(), index = latest.findIndex(entry => configurationKey(entry) === key);
        if (write(latest.filter(entry => configurationKey(entry) !== key))) {
          render(); message(dialog.dataset.removed);
          const remaining = list.querySelectorAll('.shej-favorites-remove');
          (remaining[Math.min(Math.max(index, 0), remaining.length - 1)] || dialog.querySelector('[data-favorites-close]')).focus();
        }
      });
      const add = document.createElement('button'), addText = document.createElement('span');
      add.type = 'button'; add.className = 'shej-favorites-add'; add.disabled = adding;
      add.setAttribute('aria-label', dialog.dataset.cartAdd + ': ' + item.artwork + ', ' + item.modelName);
      add.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" aria-hidden="true"><path d="M5 7h14l1 14H4L5 7Z M8 8V6a4 4 0 0 1 8 0v2 M9 14h6 M12 11v6" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      addText.textContent = dialog.dataset.cartAdd; add.append(addText);
      add.addEventListener('click', () => addToCart(item, add, addText));
      row.append(open, remove, add); list.append(row);
    }
  }
  async function addToCart(item, button, label) {
    const root = document.documentElement;
    if (adding || root.hasAttribute('data-shej-cart-busy')) return;
    adding = true; root.setAttribute('data-shej-cart-busy', 'favorites');
    list.querySelectorAll('.shej-favorites-add').forEach(entry => { entry.disabled = true; });
    button.setAttribute('aria-busy', 'true'); label.textContent = dialog.dataset.cartAdding;
    status.textContent = ''; cartLink.hidden = true;
    let added = false;
    try {
      const {addFavoriteToCart} = await import('./scl-favorite-cart.js?v=2026092203');
      const pageSections = ['main-cart-items', 'main-cart-footer'].map(id => document.getElementById(id)).filter(node => node?.dataset.id);
      const sectionIds = ['cart-drawer', 'cart-icon-bubble', ...pageSections.map(node => node.dataset.id)];
      const response = await addFavoriteToCart(item, {root: dialog.dataset.home, sectionIds});
      added = true;
      label.textContent = dialog.dataset.cartAdded; status.textContent = dialog.dataset.cartAdded; cartLink.hidden = false;
      const sections = response.sections || {}, drawer = document.querySelector('cart-drawer');
      const parser = new DOMParser();
      for (const node of pageSections) {
        const html = sections[node.dataset.id];
        if (typeof html !== 'string') continue;
        const next = parser.parseFromString(html, 'text/html').querySelector('.js-contents'), target = node.querySelector('.js-contents');
        if (next && target) target.replaceChildren(...next.childNodes);
      }
      if (typeof drawer?.renderContents === 'function' && typeof sections['cart-drawer'] === 'string' && typeof sections['cart-icon-bubble'] === 'string') {
        if (dialog.open) { handoffToCart = true; dialog.close(); }
        drawer.classList.remove('is-empty');
        drawer.setActiveElement?.(document.querySelector('[data-favorites-open]'));
        drawer.renderContents(response);
      } else if (typeof sections['cart-icon-bubble'] === 'string') {
        const next = parser.parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        if (next) document.querySelector('#cart-icon-bubble')?.replaceChildren(...next.childNodes);
      }
    } catch (error) {
      if (added) { status.textContent = dialog.dataset.cartAdded; cartLink.hidden = false; }
      else {
        status.textContent = dialog.dataset[({model_unavailable:'cartUnavailable', sold_out:'cartSoldOut', add_uncertain:'cartUncertain', product_failed:'cartFailed'})[error.message] || 'cartFailed'];
        if (error.message === 'add_uncertain') cartLink.hidden = false;
      }
    } finally {
      adding = false; root.removeAttribute('data-shej-cart-busy');
      list.querySelectorAll('.shej-favorites-add').forEach(entry => { entry.disabled = false; });
      button.removeAttribute('aria-busy'); label.textContent = added ? dialog.dataset.cartAdded : dialog.dataset.cartAdd;
    }
  }
  function show(button) {
    opener = button; items = read(); sync(); render(); status.textContent = '';
    if (dialog.open) { dialog.close(); return; }
    sheet.reset(); scrollTop = window.scrollY; dialog.show();
    dialog.querySelector('[data-favorites-close]').focus({preventScroll: true});
    if (window.scrollY !== scrollTop) window.scrollTo({top: scrollTop, behavior: 'instant'});
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-favorites-open]');
    if (button) { event.preventDefault(); show(button); }
  });
  dialog.querySelector('[data-favorites-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    if (handoffToCart) { handoffToCart = false; returnToViewer = false; return; }
    if (returnToViewer) {
      returnToViewer = false;
      saveButton?.focus({preventScroll: true});
    } else opener?.focus({preventScroll: true});
  });
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-favorite-save]');
    if (!button) return;
    event.preventDefault();
    document.dispatchEvent(new CustomEvent('shejtano:configuration-request'));
    if (!current || loading) return;
    const latest = read(), key = configurationKey(current), exists = latest.some(item => configurationKey(item) === key);
    if (!exists && latest.length >= FAVORITES_LIMIT) { message(dialog.dataset.limit); return; }
    const next = exists ? latest.filter(item => configurationKey(item) !== key) : [{...current, savedAt: Date.now()}, ...latest];
    if (write(next)) message(exists ? dialog.dataset.removed : dialog.dataset.saved);
  });
  document.addEventListener('shejtano:configuration', event => {
    current = normalizeConfiguration(event.detail); loading = Boolean(event.detail?.loading); sync();
  });
  window.addEventListener('storage', event => {
    if (event.key !== FAVORITES_KEY && event.key !== null) return;
    items = read(); sync(); if (dialog.open) render();
  });
  window.addEventListener('pageshow', () => { items = read(); sync(); });
  document.addEventListener('shopify:section:load', () => {
    sync(); document.dispatchEvent(new CustomEvent('shejtano:configuration-request'));
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && dialog.open) { event.preventDefault(); dialog.close(); }
  });
  document.addEventListener('pointerdown', event => {
    if (dialog.open && !dialog.contains(event.target) && !event.target.closest('[data-favorites-open], [data-favorite-save]')) dialog.close();
  });
  items = read(); sync();
  document.dispatchEvent(new CustomEvent('shejtano:configuration-request'));
}
